import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProdutoService } from 'almoxarifado-lib';
import { EddyAutoComplete, FuncaoService, GlobalService, Login, Memorial, MemorialItem, Produto, ProdutoUnidade } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { MemorialItemService } from './service/memorial-item.service';

declare var $: any;

@Component({
  selector: 'app-memorial-item',
  templateUrl: './memorial-item.component.html'
})
export class MemorialItemComponent implements OnInit, OnDestroy {

  @Input() public memorial: Memorial;
  @Input() login: Login;

  public imaskQtd = {
    mask: Number,
    scale: 0,
    signed: false
  };
  public produtoAutoComplete: EddyAutoComplete<Produto>;
  public itemAtual: MemorialItem;

  @ViewChild('produto_item_') campoItem: AutoComplete;
  @ViewChild('quantidade_') campoQtde: ElementRef;
  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected injector: Injector,
    public funcaoService: FuncaoService,
    protected messageService: MessageService,
    protected globalService: GlobalService,
    protected produtoService: ProdutoService,
    protected itemService: MemorialItemService) {
  }

  ngOnInit(): void {
    this.produtoAutoComplete = new EddyAutoComplete(null, this.produtoService,
      'id', ['codigo', 'nome'], { orderBy: 'codigo,nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public adicionar() {
    if (this.memorial.itens && this.memorial.itens.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de incluir outro item');
      return;
    }

    this.itemAtual = new MemorialItem();
    this.itemAtual.editavel = true;

    if (!this.memorial.itens || this.memorial.itens.length === 0)
      this.memorial.itens = [];

    this.memorial.itens.unshift(this.itemAtual);
    this.btnAdicionar.nativeElement.disabled = true;
    this.focarItem();
  }

  public editar(item: MemorialItem) {
    if (this.memorial.itens && this.memorial.itens.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de editar outro item');
      return;
    }

    this.itemAtual = item;
    this.itemAtual.editavel = true;
    this.produtoService.obter({ id: this.itemAtual.produto.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.itemAtual.produto = res;
        this.focarItem();
      }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error }));
    this.btnAdicionar.nativeElement.disabled = true;
  }

  public salvar(item: MemorialItem) {
    try {

      if (!item.produto) {
        throw new Error('Informe o produto/serviço!');
      }
      if (!item.quantidade || +item.quantidade <= 0) {
        throw new Error('Informe a quantidade!');
      }
      if (this.memorial.itens.find(m => m.produto.id === item.produto.id && m !== item)) {
        this.itemAtual.produto = undefined;
        this.itemAtual.quantidade = undefined;
        throw new Error('Item já incluído neste lote!');
      }

      item.descricao = this.itemAtual.produto.descricao;

      this.btnAdicionar.nativeElement.disabled = false;
      this.itemAtual.editavel = false;
      this.memorial.quantidade = 1;
    } catch (e) {
      toastr.warning(e, 'Validação');
      throw e;
    }
  }

  public cancelar(item: MemorialItem, index: number) {
    this.itemAtual = item;

    if (!item.id && !this.itemAtual.quantidade && !this.itemAtual.produto) {
      this.memorial.itens.splice(index, 1);
    } else {
      this.itemAtual.editavel = false;
    }
    this.btnAdicionar.nativeElement.disabled = false;
  }

  public remover(item: Memorial, index: number) {
    if (item.id) {
      this.itemService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          toastr.info('Registro removido com sucesso!', 'Exclusão');
          this.memorial.itens.splice(index, 1);
          this.btnAdicionar.nativeElement.disabled = false;
          this.memorial.quantidade = 1;
        }, (err) => toastr.error(err.error.payload));
    } else {
      this.memorial.itens.splice(index, 1);
      this.btnAdicionar.nativeElement.disabled = false;
      this.memorial.quantidade = 1;
    }
  }

  private focarItem() {
    setTimeout(() => this.campoItem ? this.campoItem.focusInput() : null, 500);
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public abrirConsultaProduto() {
    $('#dialogProdutoBusca').modal('show');
    $('#dialogMemorialItem').modal('hide');
  }

  public callbackProduto(prod: Produto) {
    console.log(prod, this.itemAtual)
    if (this.itemAtual) {
      this.itemAtual.produto = prod;
      setTimeout(() => this.campoQtde ? this.campoQtde.nativeElement.focus() : null, 500);
      $('#dialogMemorialItem').modal('show');
    }
  }
}
